<div class="container mt-5">
  <services-banner></services-banner>
  <offer-services></offer-services>
</div>
<mini-banner></mini-banner>
<subs-plans></subs-plans>
<div class="container">
  <frequently-questions></frequently-questions>
</div>